// import { Theme } from '@mui/material';

interface OnlineBookingTokenOptions {
  keyOB?: any;
  keyVX?: any;
}

/**
 * Returns the appropriate token based on whether the application is 'OnlineBooking'.
 * This is a port of the design system utility for local use.
 * The theme is typed as any to avoid conflicts between different versions
 * of @mui/material installed in the project and design system.
 */
export const getOnlineBookingTokenByTheme = (
  theme: any,
  options: OnlineBookingTokenOptions,
) => {
  if (theme?.palette?.LUX?.applicationName === 'OnlineBooking') {
    return options.keyOB;
  }
  return options.keyVX;
};
